module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.liveInfo && (_vm.liveInfo.roomID !== 33 || _vm.hasBuyDing)) ? _c('div', {
    ref: "notice",
    staticClass: "jin-notice"
  }, [_c('div', {
    staticClass: "jin-notice__list"
  }, _vm._l((_vm.notice.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "jin-notice__item"
    }, [_c('div', {
      staticClass: "jin-notice__wrap"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "jin-notice__ad"
  }, [_c('div', {
    staticClass: "jin-notice__wrap"
  }, [_c('h3', [_vm._v(_vm._s(_vm.notice.infoTitle))]), _vm._v(" "), _vm._l((_vm.notice.infoList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "jin-notice__contact"
    }, [(item.qrcode) ? _c('img', {
      style: (item.style),
      attrs: {
        "src": item.qrcode
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.number))])])])
  })], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63090483","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/notice.vue
// module id = hSG4
// module chunks = 2 3 4 6 7 8 9